import axios from 'axios';
import '../config.js';

const appendParam = (params, key, value) => {
  if (value === null || value === undefined || value === '') {
    return;
  }
  params.append(key, String(value));
};

const buildQueryString = (query = {}) => {
  const params = new URLSearchParams();
  appendParam(params, 'initDate', query.initDate);
  appendParam(params, 'endDate', query.endDate);
  appendParam(params, 'page', Number.isFinite(Number(query.page)) ? Number(query.page) : 0);
  appendParam(params, 'pageSize', Number.isFinite(Number(query.pageSize)) ? Number(query.pageSize) : 100);
  return params.toString();
};

/**
 * @param {import('./types/supportClientStatusLogs').SupportClientStatusLogRequest} payload
 * @returns {Promise<import('./types/supportClientStatusLogs').ClientStatusLog[]>}
 */
export const getSupportClientStatusLogs = async (payload, appProviderId) => {
  const token = localStorage.getItem('token');
  const query = buildQueryString(payload.query || {});

  let url =
    global.config.url +
    `/support/clientstatuslogs/${encodeURIComponent(String(payload.clientName))}/${encodeURIComponent(String(payload.locationName))}/${payload.customerId}${
      query ? `?${query}` : ''
    }`;

  if (appProviderId !== null && appProviderId !== undefined && appProviderId !== '') {
    const sep = url.includes('?') ? '&' : '?';
    url = `${url}${sep}appProviderId=${appProviderId}`;
  }

  const response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return Array.isArray(response.data) ? response.data : [];
};

const supportClientStatusLogsApi = {
  getSupportClientStatusLogs,
};

export default supportClientStatusLogsApi;
